export default __webpack_public_path__ + "static/media/average.bc61e890.svg";